import { render, staticRenderFns } from "./produits_in_category.vue?vue&type=template&id=71c98cce&scoped=true&"
import script from "./produits_in_category.vue?vue&type=script&lang=js&"
export * from "./produits_in_category.vue?vue&type=script&lang=js&"
import style0 from "./produits_in_category.vue?vue&type=style&index=0&id=71c98cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c98cce",
  null
  
)

export default component.exports